import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Container, Page } from '@ui';
import { AI_TOOLS } from '@constants';
import { GenericQuery } from '@features/query/GenericQuery';
import { ModeContext } from '@/contexts/ModeContext';
import { ROUTES } from '@constants/routes';
import { useNavigate } from 'react-router';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { AdvancedSettingsButton } from '@containers/DigitalAnalyst/AdvancedSettings';
import { Body1 } from '@ui';
import { AnswerConfigContext } from '@/contexts/AnswerConfigContext';
import { QueryControllerProvider } from '@/contexts/QueryControllerContext';
import { AdvancedSettingsProvider } from '@/contexts/AdvancedSettingsContext';
import { DOCUMENT_SELECTION_MODES } from '@features/document/DocumentSelectionModal/modes';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
`;

function Heading() {
  return (
    <HeadingWrapper>
      <Body1 bold>Generic Query</Body1>
    </HeadingWrapper>
  );
}

const tool = AI_TOOLS.QUERY;
const prefillQuestions = [
  'What does this company do?',
  'How does it generate revenue?',
  'What products / services does it sell?',
  'How large are its target markets?',
  'Who are its key customers?',
  'How is it differentiated from its competitors?',
  'How does it generate earnings?',
  'What are its reported operating segments?',
  'What % of revenue and operating income is each segment?',
  'How else does the company break down revenue and earnings (such as by product and/or service, by geography)?',
  'What’s its strategy to grow sales and earnings?',
  'What are its long term financial targets?',
  'What are recent trends in sales and profitability, overall and by segment?',
  'What’s its capital structure? Is it changing, and if so, how?',
  'What’s its investment strategy? How does it fund growth? Is it changing, and if so, how?',
  'What are the risks to the company’s business?',
];

const answerConfig = {
  enableMoreDetail: true,
  enableLinks: true,
  ignoreLatex: false,
  enableRating: true,
  enableShare: true,
};
const modeContext = {
  tool,
  prefillQuestions,
  showCompanyTags: true,
  enableFollowUpQuestions: true,
  autoSelectRecentDocuments: true,

  documentSelectionModes: [DOCUMENT_SELECTION_MODES.company, DOCUMENT_SELECTION_MODES.myUploads],
  defaultActiveDocumentSelectionMode: DOCUMENT_SELECTION_MODES.company,
};

function Content() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  return (
    <Page>
      <BackArrowButton onClick={onGoBack} />
      <AdvancedSettingsButton tool={tool} />

      <Container top={40}>
        <ModeContext.Provider value={modeContext}>
          <AdvancedSettingsProvider>
            <QueryControllerProvider>
              <AnswerConfigContext.Provider value={answerConfig}>
                <GenericQuery heading={<Heading />} />
              </AnswerConfigContext.Provider>
            </QueryControllerProvider>
          </AdvancedSettingsProvider>
        </ModeContext.Provider>
      </Container>
    </Page>
  );
}

export function Sandbox() {
  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Content />
      </Body>
    </PageWrapper>
  );
}
